<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <StaticViewHeading icon="widgets" subtitle="Administración de módulos disponibles en el proyecto" />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions :show-shortcut="false" /></div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': table.mostrarFiltros }"
                        v-b-tooltip.hover.bottom
                        :title="table.mostrarFiltros ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="table.mostrarFiltros ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="table.mostrarFiltros = !table.mostrarFiltros">
                <AppIcon name="filter" :fill="table.mostrarFiltros" />
              </b-button>
            </div>
          </div>
        </section>
        <b-collapse v-model="table.mostrarFiltros">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 280px;">
              <label class="filter-label" for="modules-search-filter">Búsqueda</label>
              <b-input-group size="sm">
                <b-form-input id="modules-search-filter" type="text" placeholder="Buscar por nombre o ID" v-model="table.filter" />
                <b-input-group-append>
                  <b-button variant="link" class="list-view-ghost-btn" :disabled="!table.filter" @click="table.filter = ''" v-b-tooltip.hover title="Limpiar búsqueda" aria-label="Limpiar búsqueda">
                    <AppIcon name="close" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <div class="list-view-filter" style="width: 170px;">
              <label class="filter-label" for="modules-support-filter">Soporte</label>
              <b-form-select id="modules-support-filter" v-model="table.support" size="sm" :options="supportOptions" />
            </div>
            <div class="list-view-filter" style="width: 170px;">
              <label class="filter-label" for="modules-active-filter">Estado</label>
              <b-form-select id="modules-active-filter" v-model="table.active" size="sm" :options="activeOptions" />
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-card no-body>
        <b-table class="app-table"
                    responsive="sm"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="filteredItems"
                    :fields="tableFields"
                    :tbody-tr-class="rowClass"
                    :stacked="isMobileViewport ? 'md' : false">

                  <template v-slot:cell(name)="data">
                      <span :class="{ 'text-danger': data.item.deprecated }">{{data.item.name.toUpperCase()}}</span>
                      <b-badge variant="danger" class="ml-1" v-if="data.item.deprecated" v-b-tooltip.hover title="Este módulo está discontinuado, ya no tiene soporte">
                        <AppIcon name="warning" class="mr-1" />Sin soporte
                      </b-badge>
                  </template>

                  <template v-slot:cell(description)="data">
                      <b>{{data.item.title.substring(data.item.title.indexOf(".") + 1)}}</b><br>
                      {{data.item.description}}
                  </template>

                  <template v-slot:cell(dependence)="data">
                    <div v-html="getDependences(data.item.dependence)"></div>
                  </template>

                  <template v-slot:cell(active)="data">
                      <b-badge variant="success" v-if="data.item.active">Activo</b-badge>
                      <b-badge variant="danger" v-if="!data.item.active">Inactivo</b-badge>
                  </template>

                  <template v-slot:cell(f_action)="data">
                    <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="app-table-action-toggle" v-if="!data.item.deprecated">
                      <template #button-content><AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" /><span v-if="isMobileViewport" class="app-table-action-label">Opciones</span></template>
                      <b-dropdown-item @click="activarModule(data.item)" v-if="!data.item.active">
                        <AppIcon name="check" class="text-success mr-1" /> Activar
                      </b-dropdown-item>
                      <b-dropdown-item @click="desactivarModule(data.item)" v-if="data.item.active">
                        <AppIcon name="block" class="text-danger mr-1" /> Desactivar
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>

        </b-table>

        <div class="app-table-footer modules-table-footer">
          <span class="list-view-toolbar__count">{{ filteredItems.length }} registros</span>
        </div>

      </b-card>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import StaticViewHeading from '@/components/inc/module/StaticViewHeading'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    data: () => {
      return {
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID'},
            {key: 'name', label: 'Nombre'},
            {key: 'description', label: 'Descripción'},
            {key: 'active', label: 'Activar'},
            {key: 'f_action', label:''},
          ],
          filter: null,
          support: 'supported',
          active: 'all',
          mostrarFiltros: false,
        },
        arrModules: [],
        isMobileViewport: false,
      }
    },
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.cargar()
    },
    beforeDestroy() {
      if (this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    components: { StaticViewHeading, TabHeaderActions },
    computed: {
      tableFields () {
        return this.table.fields.map(field => field.key === 'f_action' ? Object.assign({}, field, { label: this.isMobileViewport ? 'Acción' : '', thClass: 'align-middle' }) : field)
      },
      supportOptions () {
        return [
          { value: 'supported', text: 'Con soporte' },
          { value: 'all', text: 'Todos' },
        ]
      },
      activeOptions () {
        return [
          { value: 'all', text: 'Todos los estados' },
          { value: 'active', text: 'Sólo activos' },
          { value: 'inactive', text: 'Sólo inactivos' },
        ]
      },
      filteredItems () {
        const term = String(this.table.filter || '').toLocaleLowerCase()
        return this.table.items.filter(item => {
          if (this.table.support === 'supported' && item.deprecated) return false
          if (this.table.active === 'active' && !item.active) return false
          if (this.table.active === 'inactive' && item.active) return false
          if (term && !(String(item.id).includes(term) || item.name.toLocaleLowerCase().includes(term))) return false
          return true
        })
      },
    },
    methods: {
      updateMobileViewport (event) {
        this.isMobileViewport = event.matches
      },
      cargar () {
        var result = serviceAPI.obtener()

        result.then((response) => {
          var data = response.data
          this.table.items = data
          this.arrModules = data
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });
      },
      getDependences (dependence) {
        let arrDependences = dependence.split(",")
        var result = ""
        arrDependences.forEach(element => {
          if(element) {
            result = result + "<span class='badge badge-secondary mr-1 badge-module-custom'>" + this.getNameDependence(element) + "</span>"
          }
        });
        return result
      },
      getNameDependence(id) {
        var result = ""
        this.arrModules.forEach(element => {
          if(element.id == id) {
            result = element.name
          }
        });
        return result
      },
      activarModule (item) {
        this.updateActive(item, true)
      },
      desactivarModule (item) {
        this.updateActive(item, false)
      },
      updateActive (item, active) {
        let loader = this.$loading.show();
        var result = serviceAPI.configurate([{id: item.id, active: active}])

        result.then(() => {
          loader.hide()
          this.cargar()
          this.$awn.success(active ? "Módulo activado" : "Módulo desactivado")
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },
      rowClass (item) {
        return item && item.deprecated ? 'modules-row-deprecated' : ''
      },
    }
  }
</script>
<style>
  .badge-module-custom {
    font-size: 12px;
  }
  .modules-row-deprecated {
    box-shadow: inset 3px 0 0 0 #dc3545;
    background-color: #fdecea;
  }
  .modules-table-footer {
    padding-right: 12px;
  }
</style>
